import { useSelector } from 'react-redux';
import { generatePath, Navigate, useParams } from 'react-router';
import { getIsCustomsRequiredInCheckout } from '@store/selectors/checkout';
import { CustomsStep } from './CustomsStep';
import { APP_ROUTE } from '@pages/router/routes';

export function CustomsStepHandler(): JSX.Element {
    const isCustomsRequired = useSelector(getIsCustomsRequiredInCheckout);
    const params = useParams();

    if (isCustomsRequired) {
        return <CustomsStep />;
    } else {
        return <Navigate to={generatePath(APP_ROUTE.CHECKOUT.STEP_ADDRESS, { id: params.id ?? null })} replace />;
    }
}
